import { UntypedFormGroup } from '@angular/forms';

export class FormUtils {
  _defaultFormGroup: UntypedFormGroup = null;

  set defaultFormGroup(formGroup: UntypedFormGroup) {
    this.defaultFormGroup = formGroup;
  }

  get defaultFormGroup() {
    return this.defaultFormGroup;
  }

  markFormFieldsAsTouched(formGroup: UntypedFormGroup) {
    // Validation helper
    const useFormGroup = formGroup ? formGroup : this._defaultFormGroup;
    Object.keys(useFormGroup.controls).forEach((field) => {
      const control = useFormGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
}
